import EStrikeFullZone from './EStrikeFullZone';

export default EStrikeFullZone;
